import marquee from "vanilla-marquee";
class AnnouncementMarquee extends HTMLElement {

    constructor() {
        super()
        this.init();
    }

    init() {

        new marquee( this.querySelector('.announcement-bar-marquee'), {
            delayBeforeStart: 0,
            direction:        'right',
            gap:              0,
            speed:            100
        })

        console.log('announcement marquee init')
    }
}

customElements.define('announcement-marquee', AnnouncementMarquee)